<template>
    <el-dialog title="AI互动" :close-on-press-escape="false" @close="closeDialog" :close-on-click-modal="false"
        :visible.sync="dialogVisible" width="128rem" custom-class="ai-chat-dialog">
        <div class="ai-main">
            <!-- 头部标题 -->
            <!-- <div class="header">
                <div class="header-title"><i class="el-icon-s-custom" style="margin-right: 0.6rem;"></i>智能助手</div>
                <div class="header-desc">输入建筑相关问题，AI智能分析并给出权威解答。</div>
            </div> -->

            <div class="content-area">
                <div class="right">
                    <!-- 左侧：历史对话列表 -->
                    <div class="problem">
                        <div class="problem-titel">
                            <i class="el-icon-chat-line-round"></i>
                            <span>历史对话</span>
                        </div>
                        <div class="add-chat" @click="addChat">
                            <i class="el-icon-edit"></i>创建新对话
                        </div>
                        <div class="problem-list" v-if="problemList.length > 0">
                            <div class="problem-item" :class="item.sessionId == chatId ? 'problem-item-active' : ''"
                                v-for="item in problemList" :key="item.sessionId" @click="changeChat(item)">
                                <span class="problem-item-title" v-if="replayId != item.sessionId">{{ item.title
                                }}</span>
                                <el-input v-if="replayId == item.sessionId" @blur="renameChat(item)" type="text"
                                    :ref="item.sessionId" autofocus v-model="item.title" placeholder=""></el-input>
                                <!-- <el-dropdown class="no-display"
                                    :class="item.sessionId == chatId ? 'visible-chat' : ''" trigger="hover"
                                    @click.native.stop>
                                    <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="del(item)">删除</el-dropdown-item>
                                        <el-dropdown-item @click.native="rename(item)">重命名</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown> -->
                            </div>
                        </div>
                        <div class="none" v-else>
                            <img src="@/assets/image/nodata.png" alt="">
                            <div>暂无数据</div>
                        </div>
                    </div>

                    <!-- 右侧：问答区 -->
                    <div class="answer">
                        <div class="Dialogue" ref="Dialogue">
                            <!-- 欢迎初始状态 -->
                            <div class="Questions-big-title" v-if="answerList.length == 0">
                                <div class="welcome-title">欢迎来到智能助手</div>
                                <div class="Questions-big-list">
                                    <div class="content">
                                        <div v-for="(item, index) in list2" :key="index"
                                            @click="startAnswer(item)">
                                            <span class="border"></span><span>{{ item }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 消息列表 -->
                            <div class="Question-and-Answer">
                                <div v-for="(item, index) in answerList" :key="index"
                                    class="Question-and-Answer-item-list">
                                    <!-- 用户消息 -->
                                    <div class="Question-and-Answer-item">
                                        <div v-if="item.role == 'user'" class="content-answer user-answer">
                                            <div v-if="item.fileName" class="file-tag">
                                                <i class="iconfont" :class="getFileTypeIcon(item.fileName)"></i>
                                                <span>{{ item.fileName }}</span>
                                            </div>
                                            <img v-if="item.imgPath" class="upload-img" @click="openImg(item)"
                                                :src="item.imgPath" alt="">
                                            <div class="user-text">{{ item.content }}</div>
                                        </div>
                                    </div>
                                    <!-- AI回复 -->
                                    <div v-if="item.role == 'assistant'" class="Question-and-Answer-item item-right">
                                        <div class="ball-container" v-if="loadding2 && index == nextId - 1">
                                            <div class="ball ball1"></div>
                                            <div class="ball ball2"></div>
                                            <div class="ball ball3"></div>
                                            <div class="ball ball4"></div>
                                        </div>
                                        <div class="box-card">
                                            <div class="icon-list">
                                                <el-tooltip effect="light" placement="top" content="重新生成">
                                                    <i class="el-icon-refresh" @click="refresh(index)"></i></el-tooltip>
                                                <el-tooltip effect="light" placement="top" content="复制">
                                                    <i class="el-icon-document-copy" @click="copy(item)"></i></el-tooltip>
                                            </div>
                                            <!-- 加载中 -->
                                            <div class="content-answer" v-if="loadding && index == nextId - 1">
                                                <div class="loading-dots">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </div>
                                            </div>
                                            <div class="content-answer" v-if="!loadding && index == nextId - 1 || index != nextId - 1">
                                                <div class="known" @click="openDrawer(item.webSearchVO, '联网搜索')"
                                                    v-if="item.webSearchVO && item.webSearchVO.length > 0">
                                                    已联网搜索{{ item.webSearchVO.length }}个网页></div>
                                                <div class="net known" @click="openDrawer(item.knowledgeVO, '知识库搜索')"
                                                    v-if="item.knowledgeVO && item.knowledgeVO.length > 0">
                                                    知识库搜索{{ item.knowledgeVO.length }}条记录></div>
                                                <!-- 思考过程：与答案明显区分 -->
                                                <div v-if="getThinking(item)" class="thinking-box">
                                                    <div class="thinking-box-head">
                                                        <i class="el-icon-magic-stick"></i>
                                                        <span>{{ (loadding2 && index == nextId - 1) ? '思考中...' :
                                                            '思考过程' }}</span>
                                                    </div>
                                                    <div class="thinking-box-content" v-html="getThinking(item)"></div>
                                                </div>
                                                <!-- 输出答案 -->
                                                <div class="answer-content" v-html="item.content"></div>
                                                <img v-if="item.rowImgUrl" class="upload-img" @click="openImg(item)"
                                                    :src="item.rowImgUrl" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="stop-answer" v-if="stopResp">
                                <el-button type="primary" @click="stopAnswer"
                                    icon="el-icon-switch-button" style="color: #ffffff;">停止响应</el-button>
                            </div>
                        </div>

                        <!-- 底部输入 -->
                        <div class="Questions" :class="answerList.length > 0 ? 'Questions-bottom' : ''">
                            <div v-if="upHeightShow" @click="toDown" class="upHeightShow">
                                <i class="el-icon-arrow-down"></i>
                            </div>
                            <div class="file" style="width: 20rem;" v-if="info.filePath && info.fileName">
                                <span class="file-icon" :class="['iconfont',getFileTypeIcon(info.fileName)]"></span>
                                <div class="file-info">
                                    <div class="fileName">{{ info.fileName }}</div>
                                    <div class="tip-title">{{ statusType(info.status) }} {{ info.size }}</div>
                                </div>
                                <i @click="clearFile" class="el-icon-circle-close coloseFile"></i>
                            </div>
                            <el-input autofocus ref="textarea" type="textarea" :placeholder="placeholder"
                                :autosize="{ minRows: 2, maxRows: 10 }" v-model="textarea"
                                suffix-icon="el-icon-s-promotion"></el-input>
                            <div class="control-row">
                                <div class="think-base">
                                    <el-button :type="model.enableKnowledgeSearch ? 'primary' : ''"
                                        @click="model.enableKnowledgeSearch = !model.enableKnowledgeSearch"
                                        icon="el-icon-reading">知识库搜索</el-button>
                                </div>
                                <div class="think-upload">
                                    <!-- <el-upload class="avatar-uploader" action="#" :show-file-list="false"
                                        :auto-upload="false" :on-change="handleFile">
                                        <el-tooltip effect="light" placement="top" content="文件上传"><i
                                                class="el-icon-upload2"></i></el-tooltip>
                                    </el-upload> -->
                                    <el-tooltip effect="light" placement="top" content="发送">
                                        <i class="send-btn el-icon-s-promotion" @click="submitEvent"></i>
                                    </el-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 搜索结果抽屉 -->
            <el-drawer :title="drawerTitle" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
                <div v-for="(item, index) in drawerList" :key="index" class="drawer-item">
                    <div class="num">{{ index + 1 }}</div>
                    <i v-if="item.url" class="el-icon-paperclip"></i><span v-if="item.url" class="open-link"
                        @click="openUrl(item)">打开链接</span>
                    <div class="titel" v-if="item.content" v-html="item.content">{{ item.content }}</div>
                    <div class="titel" v-if="item.title" v-html="item.title">{{ item.title }}</div>
                    <span v-if="item.snippet" class="snippet">{{ item.snippet }}</span>
                </div>
            </el-drawer>
        </div>
    </el-dialog>
</template>

<script>
import { fetchSSE, stopFetchSSE } from "@/api/sse";
import { marked } from 'marked';
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";
import {
    chatList, chatRecords, delChatRecords, renameConversation,
    findQuestionAnswerModelConfigList, uploadFileAsync, getProgress, getFileContent
} from '@/api/questionAndAnswer';
export default {
    name: "aiChat",
    components: {},
    data() {
        return {
            dialogVisible: true,
            placeholder: "输入您要搜索的内容",
            upHeightShow: false,
            srcList: [],
            info: { status: "", size: "", filePath: "", fileName: "" },
            replayId: "",
            chatId: "",
            drawer: false,
            drawerList: [],
            drawerTitle: "",
            problemList: [],
            problemListTotal: 0,
            list2: [
                "城市更新的关键要点是什么？",
                "城市更新典型案例分析",
                "管网检测机器人的应用场景有哪些？",
                "如何利用AI技术实现城市的智慧化管理？",
                "数字孪生技术在智慧城市中的应用与落地",
                "视频检测技术的应用领域有哪些？",
                "建筑结构加固修复技术",
                "写一份关于智慧管廊实训基地的方案",
                "喷涂机器人的结构与传感器",
            ],
            stopResp: false,
            dom: "",
            nextId: 0,
            textarea: "",
            loadding: false,
            loadding2: false,
            sessionId: "",
            answerList: [],
            options: [],
            model: {
                sceneCode: "normal",
                enableWebSearch: false,
                enableKnowledgeSearch: false,
                sessionId: "",
                userName: this.common.getCookie("loginName"),
                modelConfigId: "qwen3.7-plus1",
                model: "qwen3.7-plus",
                skillId: "",
                fileIds: [],
            },
            copyTimer: null,
        };
    },
    created() {
        if (!this.common.getCookie("token")) {
            return
        }
        this.getChatList();
        // this.getModelList();
    },
    methods: {
        closeDialog() {
            stopFetchSSE();
            this.$emit('close');
        },
        randomSessionId(length = 32) {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        formatFileSize(bytes) {
            if (!bytes) return "";
            if (bytes < 1024) return bytes + " B";
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
            return (bytes / (1024 * 1024)).toFixed(1) + " MB";
        },
        getFileTypeIcon(fileName) {
            if (!fileName) return "icon-document";
            if (fileName.includes(".pdf")) return "icon-document";
            if (fileName.includes(".doc")) return "icon-document";
            if (fileName.includes(".docx")) return "icon-document";
            if (fileName.includes(".ppt")) return "icon-document";
            if (fileName.includes(".xlsx")) return "icon-document";
            return "icon-paperclip";
        },
        statusType(status) {
            if (!status) return "";
            if (status.includes("pending")) return "待处理";
            if (status.includes("processing")) return "处理中";
            if (status.includes("completed")) return "已完成";
            if (status.includes("failed")) return "失败";
            return status;
        },
        parseAnswerMarkdown(markdown) {
            if (!markdown) return "";
            return this.normalizeAnswerImageSrc(marked.parse(markdown));
        },
        normalizeAnswerImageSrc(html) {
            if (!html) return "";
            const imageHost = process.env.VUE_APP_OSS_IP || "https://whzdzx.zdzxtech.cn";
            return html.replace(/(<img\b[^>]*\bsrc=["'])(\/(?!\/)[^"']+)(["'][^>]*>)/gi, (match, prefix, src, suffix) => {
                const fullSrc = typeof this.$severUrl === "function" ? this.$severUrl(src) : `${imageHost}${src}`;
                return `${prefix}${fullSrc}${suffix}`;
            });
        },
        // 获取模型列表
        getModelList() {
            findQuestionAnswerModelConfigList({ current: 1, size: 10 }).then((res) => {
                this.options = res.data.records || [];
                if (this.options.length > 0) {
                    this.model.model = this.options[0].modelName;
                    this.model.modelConfigId = this.options[0].configId;
                }
            });
        },
        // 获取对话列表
        getChatList() {
            chatList({ sceneCode: "normal", current: 1, size: 100 }).then((res) => {
                this.problemList = res.data.records || [];
                this.problemListTotal = res.data.total || 0;
                if (!this.chatId && this.problemList.length > 0) {
                    this.changeChat(this.problemList[0]);
                }
            });
        },
        // 切换对话
        changeChat(item) {
            if (!item || !item.sessionId) return;
            this.finishStreaming();
            this.sessionId = item.sessionId;
            this.chatId = item.sessionId;
            this.model.sessionId = item.sessionId;
            this.stopResp = false;
            this.loadding2 = false;
            chatRecords(item.sessionId).then((res) => {
                const list = (res.data && res.data.chatMessageVOList) || [];
                this.answerList = list.map((m) => this.formatHistoryMessage(m));
                this.nextId = this.answerList.length;
                this.$nextTick(() => {
                    this.scrollBottom();
                    this.heightCopy();
                });
            });
        },
        formatHistoryMessage(m) {
            // 只有 AI 回复才按 markdown 渲染成 HTML；用户问题保持纯文本，避免出现 <p>…</p> 等标签原文
            if (m.role !== 'user') {
                m.content = this.parseAnswerMarkdown(m.content || "");
            } else {
                m.content = this.stripHtml(m.content || "");
            }
            m.checked = false;
            m.fileName = "";
            m.tools = m.tools || [];
            if (m.toolVO && m.toolVO.length > 0 && m.toolVO[0].result) {
                try {
                    const r = JSON.parse(m.toolVO[0].result);
                    m.resourceData = r.records;
                    m.webSearchVO = r.results;
                } catch (e) { /* ignore */ }
            }
            if (m.fileIds && m.fileIds.length > 0) {
                getFileContent(m.fileIds[0]).then((res) => {
                    if (res && res.data) m.fileName = res.data.fileName;
                }).catch(() => { });
            }
            if (m.reasoningContent) {
                m.reasoningContent = this.parseAnswerMarkdown(m.reasoningContent);
            }
            if (m.knowledgeVO) {
                m.knowledgeVO.forEach((k) => { if (k.content) k.content = this.parseAnswerMarkdown(k.content); });
            }
            return m;
        },
        addChat() {
            this.finishStreaming();
            this.chatId = "";
            this.sessionId = "";
            this.model.sessionId = "";
            this.model.fileIds = [];
            this.answerList = [];
            this.info = {};
            this.textarea = "";
            this.nextId = 0;
            this.$nextTick(() => {
                this.$refs.textarea && this.$refs.textarea.focus();
            });
        },
        rename(row) {
            this.replayId = row.sessionId;
            this.$nextTick(() => {
                if (this.$refs[row.sessionId] && this.$refs[row.sessionId][0]) {
                    this.$refs[row.sessionId][0].focus();
                }
            });
        },
        renameChat(row) {
            renameConversation({ sessionId: row.sessionId, title: row.title }).then((res) => {
                if (res.code == 200) {
                    this.replayId = null;
                }
            });
        },
        del(row) {
            this.$confirm("删除后，该对话将不可恢复。确认删除吗？", "永久删除对话", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                delChatRecords(row.sessionId).then((res) => {
                    if (res.code == 200) {
                        if (this.chatId == row.sessionId) this.addChat();
                        this.getChatList();
                        this.$message({ type: "success", message: "删除成功!", duration: 500 });
                    }
                });
            }).catch(() => { });
        },
        startAnswer(item) {
            this.textarea = item;
            this.submitEvent("add");
        },
        // 发送消息
        submitEvent() {
            if (!this.textarea) {
                this.$message.info("提问不能为空！");
                return;
            }
            if (this.loadding2) {
                this.$message.info("请等待上条信息响应完成！");
                return;
            }
            this.loadding = true;
            this.loadding2 = true;
            this.nextId = this.answerList.length;
            this.nextId++;
            this.answerList.push({
                role: "user",
                content: this.textarea,
                id: this.nextId,
                fileName: this.info.fileName,
                imgPath: this.info.imgPath,
                isStreaming: false,
            });
            this.info = {};
            this.placeholder = "输入您要搜索的内容";
            this.nextId++;
            this.answerList.push({
                role: "assistant",
                content: "",
                id: this.nextId,
                isStreaming: false,
                tools: [],
                webSearchVO: [],
                knowledgeVO: [],
                resourceData: [],
            });
            this.$nextTick(() => this.scrollBottom());
            this.model.message = this.textarea;
            this.textarea = "";
            this.stopResp = true;
            let sclosss = "";
            let toos = "";
            let recourse = [];
            if (!this.sessionId) {
                this.model.sessionId = this.randomSessionId();
            }
            const modelSnapshot = JSON.parse(JSON.stringify(this.model));
            fetchSSE('/ai-chat/ClientChat/sendChatMessageStream', modelSnapshot, (chunk) => {
                this.loadding = false;
                const chatItem = this.answerList[this.nextId - 1];
                if (!chatItem) return;
                if (chunk && chunk.type == "reasoning") {
                    toos += (chunk.v.text || "").replace(/\\n/g, "\n");
                    chatItem.tools[0] = this.parseAnswerMarkdown(toos);
                } else if (chunk && chunk.type == "tool_done") {
                    if (chunk.v.toolName == "searchWeb") {
                        try { chatItem.webSearchVO = JSON.parse(chunk.v.result)["results"] || []; } catch (e) { /* ignore */ }
                    }
                    try { recourse = JSON.parse(chunk.v.result)["records"] || []; } catch (e) { /* ignore */ }
                } else if (chunk && chunk.type == "metadata") {
                    chatItem.knowledgeVO = chunk.v["knowledgeVO"] || [];
                } else if (chunk && chunk.type == "token") {
                    sclosss += (chunk.v || "").replace(/\\n/g, "\n");
                    chatItem.content = this.parseAnswerMarkdown(sclosss);
                } else if (chunk && chunk.type == "done") {
                    this.loadding2 = false;
                    this.stopResp = false;
                    chatItem.resourceData = recourse;
                    if (!this.sessionId) {
                        this.sessionId = this.model.sessionId;
                        this.chatId = this.model.sessionId;
                    }
                    this.getChatList();
                }
                this.$forceUpdate();
                this.$nextTick(() => {
                    this.scrollBottom();
                    this.heightCopy();
                });
            }).catch(() => {
                this.loadding = false;
                this.loadding2 = false;
                this.stopResp = false;
                const chatItem = this.answerList[this.nextId - 1];
                if (chatItem && !chatItem.content) {
                    chatItem.content = this.parseAnswerMarkdown("服务器异常，请稍后重试");
                }
            });
        },
        finishStreaming() {
            this.loadding = false;
            this.loadding2 = false;
            this.stopResp = false;
        },
        scrollBottom() {
            this.dom = this.$refs.Dialogue;
            if (!this.dom) return;
            let scrollTop = this.dom.scrollTop;
            let windowHeight = this.dom.clientHeight;
            let scrollHeight = this.dom.scrollHeight;
            if (scrollHeight + 40 > windowHeight + scrollTop) {
                this.dom.scrollTop = scrollHeight - windowHeight + 50;
            }
        },
        toDown() {
            this.scrollBottom();
        },
        stopAnswer() {
            stopFetchSSE();
            this.stopResp = false;
            this.loadding2 = false;
        },
        // 上传文件
        handleFile(file) {
            const formData = new FormData();
            formData.append("file", file.raw);
            uploadFileAsync(formData).then((res) => {
                // 兼容拦截器的两种返回：直接返回 Blob，或返回完整 response（res.data 为 Blob）
                const blob = res instanceof Blob ? res : (res && res.data instanceof Blob ? res.data : null);
                if (!blob) {
                    this.$message.error("文件上传失败");
                    return;
                }
                const reader = new FileReader();
                reader.onload = () => {
                    let data = null;
                    try { data = JSON.parse(reader.result); } catch (e) { /* ignore */ }
                    if (data) {
                        if (data.code && data.code == 500) {
                            this.$message.error(data.errorCode || "文件解析失败");
                            return;
                        }
                        this.info.fileName = file.raw.name;
                        this.info.filePath = file.raw.name;
                        this.info.size = this.formatFileSize(file.raw.size);
                        this.info.status = "pending";
                        // this.getProcess(data.data);
                        this.$forceUpdate();
                    } else {
                        this.$message.error("文件解析失败");
                    }
                };
                reader.readAsText(blob);
            }).catch(() => {
                this.$message.error("文件上传失败");
            });
        },
        // 获取文件进度
        getProcess(taskId) {
            if (!taskId) return;
            getProgress(taskId).then((res) => {
                this.info.status = res.data.status;
                this.$forceUpdate();
                if (res.data.status == "completed" || res.data.status == "failed") {
                    this.model.fileIds = [res.data.fileId];
                    this.info.status = res.data.status;
                    return;
                }
                setTimeout(() => {
                    this.getProcess(taskId);
                }, 1000);
            }).catch(() => { });
        },
        clearFile() {
            this.info = {};
            this.model.fileIds = [];
        },
        // 查看图片
        openImg(item) {
            if (item.imgPath) this.srcList = [item.imgPath];
            if (item.rowImgUrl) this.srcList = [item.rowImgUrl];
            this.$nextTick(() => {
                this.$refs.imgRef && this.$refs.imgRef.clickHandler();
            });
        },
        openDrawer(item, text) {
            this.drawerTitle = text + " " + (item.length || 0) + "条";
            this.drawer = true;
            this.drawerList = item || [];
        },
        handleClose() {
            this.drawer = false;
        },
        openUrl(item) {
            if (item.url) window.open(item.url, "_blank");
        },
        refresh(index) {
            if (this.loadding2) {
                this.$message.info("请等待上条信息响应完成");
                return;
            }
            this.textarea = this.stripHtml(this.answerList[index - 1].content);
            this.submitEvent();
        },
        copy(item) {
            const text = this.stripHtml(item.content);
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message.success("复制成功！");
                }).catch(() => this.fallbackCopy(text));
            } else {
                this.fallbackCopy(text);
            }
        },
        fallbackCopy(text) {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            textarea.setSelectionRange(0, text.length);
            try {
                document.execCommand("copy");
                this.$message.success("复制成功！");
            } catch (e) { /* ignore */ }
            document.body.removeChild(textarea);
        },
        stripHtml(html) {
            if (!html) return "";
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || "";
        },
        // 提取思考过程内容（流式时的 tools / 历史记录里的 reasoningContent）
        getThinking(item) {
            if (!item) return "";
            let html = "";
            if (item.tools && item.tools.length) html += item.tools.join("");
            if (item.reasoningContent) html += item.reasoningContent;
            return html;
        },
        // 高亮代码块并加复制按钮
        heightCopy() {
            document.querySelectorAll("pre code").forEach((block) => {
                hljs.highlightElement(block);
                const pre = block.parentNode;
                if (!pre || pre.querySelector("[data-answer-code-copy]")) return;
                const copyButton = document.createElement("i");
                copyButton.dataset.answerCodeCopy = "true";
                copyButton.className = "el-icon-document-copy";
                copyButton.style.cssText = "position:absolute;top:0.7rem;right:1rem;z-index:1000;color:#fff;cursor:pointer;font-size:1.2rem;";
                pre.style.position = "relative";
                copyButton.addEventListener("click", () => {
                    this.copyToClipboard(block.textContent);
                });
                pre.appendChild(copyButton);
            });
        },
        copyToClipboard(text) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(() => this.$message.success("复制成功！"))
                    .catch(() => this.fallbackCopy(text));
            } else {
                this.fallbackCopy(text);
            }
        },
    },
    mounted() {
        marked.setOptions({ breaks: true, gfm: true });
        this.dom = this.$refs.Dialogue;
        if (this.dom) {
            this.dom.addEventListener("scroll", () => {
                let scrollTop = this.dom.scrollTop;
                let windowHeight = this.dom.clientHeight;
                let scrollHeight = this.dom.scrollHeight;
                this.upHeightShow = scrollTop + windowHeight + 5 < scrollHeight;
            });
        }
        this.$nextTick(() => {
            const textareaEl = this.$refs.textarea && this.$refs.textarea.$refs.textarea;
            if (textareaEl) {
                textareaEl.addEventListener("keydown", (event) => {
                    if (event.key === "Enter" && !event.shiftKey) {
                        event.preventDefault();
                        this.submitEvent();
                    }
                });
            }
        });
    },
    beforeDestroy() {
        stopFetchSSE();
    },
    watch: {},
};
</script>

<style scoped lang="less">
.ai-main {
    display: flex;
    flex-direction: column;
    height: min(75rem, calc(100vh - 16rem));
    overflow: hidden;
    background: #F1F5FF;
    border-radius: 1.6rem;
}

/* 头部 */
.header {
    padding: 1.2rem 2rem 0.8rem;
    flex-shrink: 0;

    .header-title {
        display: flex;
        align-items: center;
        font-size: 2.4rem;
        font-weight: 700;
        color: #3D87FE;
        height: 3rem;
        overflow: hidden;
    }

    .header-desc {
        color: #7D859D;
        font-size: 1.4rem;
        margin-top: 0.4rem;
    }
}

/* 内容区 */
.content-area {
    flex: 1;
    min-height: 0;
    display: flex;
    padding: 2rem;
}

.right {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
    border-radius: 1.6rem;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid #E9EEF7;
}

/* 左侧历史 */
.problem {
    width: 22rem;
    box-sizing: border-box;
    padding: 1.6rem 1.2rem;
    text-align: left;
    border-right: 1px solid #E9EEF7;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .problem-titel {
        display: flex;
        align-items: center;
        font-size: 1.5rem;
        font-weight: 700;
        color: #262626;
        margin-bottom: 1.4rem;

        i {
            margin-right: 0.6rem;
            color: #3D87FE;
        }
    }

    .add-chat {
        background: #3D87FE;
        color: #fff;
        cursor: pointer;
        padding: 0.9rem 1rem;
        border-radius: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.4rem;
        margin-bottom: 1.2rem;
        transition: all 0.2s;

        i {
            margin-right: 0.5rem;
        }

        &:hover {
            background: #2f76e8;
        }
    }

    .problem-list {
        flex: 1;
        overflow-y: auto;
        min-height: 0;
    }

    .problem-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 1.3rem;
        cursor: pointer;
        padding: 0.9rem 0.8rem;
        border-radius: 0.8rem;
        margin-bottom: 0.6rem;
        color: #444;
        border: 1px solid transparent;
        transition: all 0.2s;

        .problem-item-title {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &:hover {
            border: 1px solid #3D87FE;
            color: #3D87FE;
        }
    }

    .problem-item-active {
        border: 1px solid #3D87FE;
        color: #3D87FE;
        background: #F1F5FF;
    }

    .none {
        text-align: center;
        color: #a5aab5;
        font-size: 1.3rem;
        margin-top: 3rem;

        img {
            width: 6rem;
            display: block;
            margin: 0 auto 0.8rem;
        }
    }
}

/* 右侧问答 */
.answer {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    height: 100%;
    overflow: hidden;
    padding: 1.2rem 1.6rem 1.6rem;
}

.Dialogue {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    white-space: normal;
    margin-bottom: 1rem;
    min-height: 0;

    /* 欢迎 */
    .Questions-big-title {
        text-align: center;
        margin-top: 8rem;

        .welcome-title {
            font-size: 2.6rem;
            font-weight: 700;
            color: #262626;
        }

        .Questions-big-list {
            margin-top: 2rem;
            width: 60rem;

            .content {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;

                div {
                    margin: 0.6rem;
                    display: flex;
                    align-items: center;
                    background: #f1f5ff;
                    border-radius: 1rem;
                    cursor: pointer;
                    padding: 0.8rem 1.4rem;
                    color: #262626;
                    font-size: 1.4rem;
                    line-height: 2.4rem;
                    transition: all 0.2s;

                    .border {
                        display: none;
                    }

                    &:hover {
                        background: #3D87FE;
                        color: #fff;
                    }
                }
            }
        }
    }
}

/* 消息列表 */
.Question-and-Answer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.Question-and-Answer-item-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.8rem;
}

.Question-and-Answer-item {
    display: flex;
    justify-content: flex-end;
    width: calc(100% - 40px);
    max-width: 100%;
    position: relative;
    box-sizing: border-box;
}

.Question-and-Answer-item.item-right {
    justify-content: flex-start;
}

.content-answer {
    text-align: left;
    padding: 0.6rem 1rem;
    min-height: 2.5rem;
    border-radius: 1rem;
    word-break: break-all;
    word-wrap: break-word;
}

.user-answer {
    background: #EAF1FF;
    color: #262626;
    border-radius: 1rem 0.2rem 1rem 1rem;
    margin-right: 1rem;

    .file-tag {
        display: flex;
        align-items: center;
        font-size: 1.6rem;
        color: #3D87FE;
        margin-bottom: 0.4rem;

        i {
            margin-right: 0.4rem;
            font-size: 1.4rem;
        }
    }

    .upload-img {
        width: 6rem;
        height: 6rem;
        border-radius: 0.6rem;
        margin-bottom: 0.4rem;
    }

    .user-text {
        white-space: pre-wrap;
    }
}

.box-card {
    width: 100%;
    border-radius: 0.8rem;
    padding-bottom: 1rem;
    position: relative;
}

.icon-list {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;

    i {
        font-size: 1.6rem;
        border-radius: 0.4rem;
        padding: 0.2rem;
        cursor: pointer;
        margin-right: 0.6rem;
        color: #A2C2FC;

        &:hover {
            color: #3D87FE;
        }
    }
}

/* 思考过程：与答案明显区分 */
.thinking-box {
    background: #f6f8fb;
    border-left: 3px solid #c8dcff;
    border-radius: 0.6rem;
    padding: 0.8rem 1rem;
    margin-bottom: 1rem;
    color: #8a94a6;
    font-size: 1.3rem;
    line-height: 1.8rem;

    .thinking-box-head {
        display: flex;
        align-items: center;
        font-size: 1.3rem;
        color: #7d859d;
        font-weight: 600;
        margin-bottom: 0.6rem;

        i {
            margin-right: 0.4rem;
            color: #3D87FE;
        }
    }

    /deep/ p {
        margin-block-start: 0;
        margin-block-end: 0.3rem;
    }

    /deep/ pre {
        background: #f0f2f5;
        color: #6b7280;
        border-radius: 0.4rem;
        padding: 0.6rem;
        overflow: auto;
        position: relative;
    }
}

/* 输出答案：更突出 */
.answer-content {
    font-size: 1.4rem;
    color: #262626;
    line-height: 2.2rem;

    /deep/ p {
        margin-block-start: 0;
        margin-block-end: 0.6rem;
    }

    /deep/ pre {
        background: #282c34;
        color: #abb2bf;
        border-radius: 0.6rem;
        padding: 1rem;
        overflow: auto;
        position: relative;
    }
}

/* 知识库标识 */
.known {
    cursor: pointer;
    text-align: left;
    padding-left: 0.8rem;
    margin-bottom: 0.8rem;
    border-radius: 0.8rem;
    width: 14rem;
    height: 2.4rem;
    font-size: 1.2rem;
    line-height: 2.4rem;
    background-color: #e9f2ff;
    color: #3d87fe;
}

/* 加载小球 */
.ball-container {
    left: -0.6rem;
    position: relative;
    width: 2rem;
    height: 2rem;
    animation: rotate 2s linear infinite;
}

.ball {
    position: absolute;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background: linear-gradient(45deg, #4facfe, #00f2fe);
}

.ball1 {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(53, 105, 255, 0.6);
}

.ball2 {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #3569ff;
}

.ball3 {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(53, 105, 255, 0.2);
}

.ball4 {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(53, 105, 255, 0.4);
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* 加载点 */
.loading-dots {
    display: flex;
    gap: 0.4rem;
}

.dot {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background-color: #ccc;
    opacity: 0.3;
    animation: pulse 1.5s infinite ease-in-out;
}

.dot:nth-child(1) {
    animation-delay: 0s;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 0.3;
        transform: scale(0.9);
    }

    50% {
        opacity: 1;
        transform: scale(1.1);
    }
}

/* 停止响应 */
.stop-answer {
    text-align: center;
    margin-top: 0.6rem;
    color: #ffffff;
}

/* 输入框 */
.Questions {
    position: relative;
    flex-shrink: 0;
    background-color: #fff;
    border: 1px solid #DFEAFB;
    border-radius: 1.2rem;
    padding: 0.6rem 0.8rem 0.6rem;
    width: calc(100% - 40px);
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
}

/deep/ .el-textarea__inner {
    resize: none;
    background-color: transparent;
    color: #444;
    font-size: 1.4rem;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

.control-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0.4rem 0;

    .think-base {
        /deep/ .el-button {
            border: 1px solid #c8dcff;
            border-radius: 1.2rem;
            color: #3d87fe;
            background: #EAF1FF;
        }

        /deep/ .el-button--primary {
            background-color: #3D87FE !important;
            border: 1px solid #3D87FE;
            color: #fff;
        }
    }

    .think-upload {
        display: flex;
        align-items: center;

        i {
            color: #3D87FE;
            font-size: 2rem;
            cursor: pointer;
            margin-left: 1rem;

            &:hover {
                opacity: 0.8;
            }
        }

        .send-btn {
            font-size: 2rem;
        }
    }
}

/* 上传文件显示 */
.file {
    display: flex;
    align-items: center;
    margin: 0 0.4rem 0.6rem;
    padding: 0 0.8rem;
    width: 100%;
    height: 4rem;
    border-radius: 0.8rem;
    border: 1px solid #DFEAFB;
    position: relative;

    .file-icon {
        font-size: 2rem;
        color: #3D87FE;
    }

    .file-info {
        margin-left: 0.6rem;
        flex: 1;
        overflow: hidden;

        .fileName {
            font-size: 1.3rem;
            color: #444;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .tip-title {
            font-size: 1.2rem;
            color: #81858c;
        }
    }

    .coloseFile {
        cursor: pointer;
        color: #a5aab5;
        margin-left: 0.6rem;

        &:hover {
            color: #3D87FE;
        }
    }
}

/* 回到顶部 */
.upHeightShow {
    cursor: pointer;
    position: absolute;
    z-index: 100;
    top: -2.5rem;
    right: 0.6rem;
    height: 2.4rem;
    width: 2.4rem;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #fff;
    box-shadow: 0 0 0.4rem rgba(0, 0, 0, 0.12);
    text-align: center;
    line-height: 2.4rem;
    color: #000;
    font-size: 1.4rem;

    &:hover {
        background: #eee;
    }
}

.drawer-item {
    position: relative;
    margin: 0 1.2rem;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    border-radius: 1rem;
    padding: 0.8rem;
    flex-direction: column;
    margin-bottom: 0.8rem;

    .num {
        top: 0.4rem;
        left: 0.4rem;
        text-align: center;
        line-height: 1.2rem;
        width: 1.2rem;
        height: 1.2rem;
        position: absolute;
        border-radius: 50%;
        background-color: #e9f2ff;
        color: #3d87fe;
    }

    .titel {
        color: #444;
        font-size: 1.4rem;
        margin-top: 0.4rem;
        word-break: break-all;
    }

    .snippet {
        color: #aaa;
        font-size: 1.3rem;
        margin-top: 0.4rem;
    }

    .open-link {
        color: #3D87FE;
        cursor: pointer;
        margin-left: 1.4rem;
    }
}

.upload-img {
    width: 6rem;
    height: 6rem;
    border-radius: 0.6rem;
    margin-right: 0.6rem;
    cursor: pointer;
}

.visible-chat {
    display: flex !important;
}

.no-display {
    display: none;
}

.problem-item:hover {
    .el-dropdown {
        display: flex !important;
    }
}

/deep/ .el-dialog__body {
    padding: 1.4rem !important;
}
/deep/li{
    list-style-type: none !important;
}
/deep/.el-button--primary.is-plain {
    color: #ffffff !important;
}
</style>
